import { CHECKBOX_SELECTION_COLUMN_WIDTH as e, DRAG_AND_DROP_COLUMN_WIDTH as i } from "./index.es531.js";
const d = (t, o, _) => t ? t + (o ? e : 0) + (_ ? i : 0) : void 0, D = (t, o, _) => d(t, o, _), O = (t, o, _) => d(t, o, _);
export {
  d as getAdjustedWidth,
  O as getMaxWidth,
  D as getMinWidth
};
//# sourceMappingURL=index.es2348.js.map
